<template>
  <frontoffice-frame class="booking-group">
    <form-base type="group"
               page-title="group.form.title"
               :form-data="groupData"
               :callbacks="{ group: onConfirm }"
               :default-submit-button="false"
               invoked-submit-button-name="group"
    >
      <p class="message-for-user">
        {{ $t('group.info') }}
      </p>

      <date-range class="dates" v-model="groupData.dates" ref="dates"
                  v-on:input="setRequestMaxDate"
      />

      <text-input class="destination" faClass="map-marker" ref="destination"
                  label="group.form.destination.label" name="destination"
                  placeholder="group.form.destination.placeholder"
                  v-model="groupData.destination"
      />

      <text-area-input class="description" label="group.form.description.label"
                       name="description" v-model="groupData.description"
                       ref="description"
      />

      <text-input class="budget" faClass="euro-sign" ref="roomBudget"
                  label="group.form.budget.label" name="budget"
                  placeholder="group.form.budget.placeholder"
                  v-model="groupData.roomBudget"
      />

      <text-input class="hotel-type" faClass="fas fa-hotel" ref="requestedHotelType"
                  label="group.form.hotel.label" name="budget"
                  placeholder="group.form.hotel.placeholder"
                  v-model="groupData.requestedHotelType"
      />

      <date-input class="row request" label="group.form.request.label"
                  placeholder="group.form.request.placeholder"
                  name="request" v-model="groupData.requestDate"
                  :max-date="requestMaxDate" ref="requestDate" :required="false"
      />

      <div class="submitForm centered-button">
        <submit-button name="group" class="btn"/>
      </div>
    </form-base>
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import dateRange from '@/components/frontoffice/form/baseInput/dateRange'
import dateInput from '@/components/frontoffice/form/baseInput/date'
import textInput from '@/components/frontoffice/form/baseInput/text'
import numberInput from '@/components/frontoffice/form/baseInput/number'
import hotelType from '@/components/frontoffice/form/hotelType'
import textAreaInput from '@/components/frontoffice/form/baseInput/textArea'
import formBase from '@/components/frontoffice/form/base'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import submitButton from '@/components/frontoffice/form/baseInput/submit'

export default {
  components: {
    frontofficeFrame,
    dateInput,
    dateRange,
    textInput,
    numberInput,
    hotelType,
    textAreaInput,
    formBase,
    submitButton
  },

  mixins: [formMethods],

  data () {
    return {
      groupData: {
        dates: {
          from: null,
          to: null
        },
        destination: null,
        description: null,
        roomBudget: null,
        requestedHotelType: null,
        requestDate: null
      },
      requestMaxDate: new Date()
    }
  },

  methods: {
    setRequestMaxDate (maxDate) {
      this.requestMaxDate = maxDate.from || maxDate.to
    },

    onConfirm (data) {
      this.$router.push({
        name: 'offline_request_confirm'
      })
    }
  }
}
</script>
